import script from "./SplitTimeline.vue?vue&type=script&setup=true&lang=ts"
export * from "./SplitTimeline.vue?vue&type=script&setup=true&lang=ts"

import "./SplitTimeline.vue?vue&type=style&index=0&id=d636096a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d636096a"]])

export default __exports__